import {actions as A} from '../../constants/actions';

const prevCompletedStepSignFalse = () => {
  return (dispatch) => {
    dispatch({
      type: A.PREVIOUSLY_COMPLETED_STEP_SIGN_FALSE,
    });
  }
};

export {prevCompletedStepSignFalse}
